import { Constants } from "appConstants";
import { IcoHeaderInfoWarning } from "assets/icons";
import { HeaderInfo } from "components";

export default function Page404() {
	return (
		<HeaderInfo
			buttonText="Voltar"
			href="/"
			icon={<IcoHeaderInfoWarning />}
			subtitle={Constants.strings.pages.notFound.subtitle}
			title={Constants.strings.pages.notFound.title}
		/>
	);
}
